module.exports = __webpack_public_path__ + "assets/img/main-type-2.73b31225.svg";